<template>
  <VDialogV3
      id="transport-downtime-card"
      width="500px"
      position="center"
      :entity="localDowntime"
      title="Простой"
      :submit-method="submit"
  >
      <section>
          <VDateRangeInput
            v-model="localDowntime.period"
            label="Период простоя"
            layout="vertical"
            required
          />

          <VInput
            v-model="localDowntime.paymentDocument"
            label="Invoice"
            layout="vertical"
          />

          <VFormItem label="Стоимость простоя">
            <VInputNumberRusV2
                v-model="localDowntime.cost"
                :type="Sum"
                layout="vertical"
                required
            />

            <VSelect
                v-model="currency"
                :options="$core.currencies.currencies"
                :clearable="false"
                option-identity="code"
                disabled
                option-label="symbol"
                required
            />
          </VFormItem>

          <VTextarea
              v-model="localDowntime.reason"
              label="Причина"
              layout="vertical"
              placeholder="Опишите причину простоя..."
          >
            <template #helper-text>
              <div class="reason-presets">
                <VButton
                    v-for="preset in reasonPresets"
                    :key="preset"
                    @click="setReason(preset)"
                >
                  {{ preset }}
                </VButton>
              </div>
            </template>
          </VTextarea>
      </section>
  </VDialogV3>
</template>

<style lang="scss" src="./TransportDowntimeCard.scss" />

<script lang="ts">

import TransportDowntime         from "@/domains/TransportDowntime/TransportDowntime";
import TransportDowntimesService from "@/domains/TransportDowntime/TransportDowntimesService";
import Sum                       from "@/core/types/Sum";

export default defineComponent({
  name: 'TransportDowntimeCard',

  props: {
    downtime: {
      type: Object as PropType<TransportDowntime>,
      required: true,
    },
  },

  emits: [
    'transportDowntime:created',
    'transportDowntime:updated',
  ],

  setup() {
    return {
      Sum,
    }
  },

  data() {
    return {
      localDowntime: this.$core.utils.cloneDeep(this.downtime),
      reasonPresets: TransportDowntime.REASON_PRESETS,
    };
  },

  computed: {
    currency: {
      set({ code }) {
        this.localDowntime.currencyCode = code;
      },
      get() {
        return this.$core.utils.money.getCurrencyByCode(this.localDowntime.currencyCode);
      }
    },
  },

  methods: {
    setReason(preset: string): void {
      this.localDowntime.reason = preset;
    },

    async submit(): Promise<boolean> {
      let event: string;

      if (this.localDowntime.isExisting === true) {
        event = TransportDowntime.Events.Updated;
      }
      else {
        event = TransportDowntime.Events.Created;
      }

      const id = await TransportDowntimesService.upsert(this.localDowntime);

      if (this.$core.utils.isNullOrUndefined(id) === false) {
        // ситуация не типичная, но просить делать нормальный add, update уже не буду, слишком много времени уже ушло на прототип
        this.localDowntime.id = id;

        this.$emit(event, this.localDowntime);

        return true;
      }
      else {
        return false;
      }
    },
  },
});
</script>